/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect } from 'react'

declare global {
  interface Window {
    LivingActor: any
  }
}

const LivingActorChatbot: FC = () => {
  useEffect(() => {
    if (!window.LivingActor) {
      return console.error('LivingActor is not defined')
    }

    const assistant = new window.LivingActor.Assistant({
      ref: '6Mzcy8Vbn52Xl5Wan5WZ',
      config: 'itf_Responsive.xml',
      autoLaunch: false,
    })

    return () => {
      assistant.removeCallButton()
      assistant.close()
      assistant.destroy()
    }
  }, [])

  return null
}

export default LivingActorChatbot
